import { differenceInDays } from 'date-fns';

import { PlanningDataFragment } from '@spotify/confidence-graphql';

export function usePlanningDates(
  planning?: Pick<PlanningDataFragment, 'planned' | 'actual'> | null,
) {
  const today = new Date();

  const plannedStartDate = planning?.planned?.startTime
    ? new Date(planning?.planned?.startTime)
    : null;
  const plannedEndDate = planning?.planned?.endTime
    ? new Date(planning?.planned?.endTime)
    : null;
  const remainingDays = plannedEndDate
    ? differenceInDays(plannedEndDate, today)
    : null;

  const plannedRuntime =
    plannedStartDate && plannedEndDate
      ? differenceInDays(plannedEndDate, plannedStartDate) + 1
      : null;

  const actualStartDate = planning?.actual?.startTime
    ? new Date(planning?.actual?.startTime)
    : null;
  const actualEndDate = planning?.actual?.endTime
    ? new Date(planning?.actual?.endTime)
    : null;

  const currentRuntime =
    actualStartDate && today ? differenceInDays(today, actualStartDate) : 0;

  const actualRuntime =
    actualStartDate && actualEndDate
      ? differenceInDays(actualEndDate, actualStartDate) + 1
      : null;

  const currentRemainingRuntime =
    actualStartDate && plannedEndDate
      ? differenceInDays(plannedEndDate, actualStartDate)
      : null;

  function calculateProgress() {
    if (currentRuntime === null || currentRemainingRuntime === null) {
      return null;
    }
    if (currentRemainingRuntime === 0) {
      return 100;
    }
    return Math.min(
      Math.max(0, Math.round((currentRuntime / currentRemainingRuntime) * 100)),
      100,
    );
  }

  const progress = calculateProgress();

  // If the experiment is estimated or not.
  const isRuntimeUnknown = !Boolean(plannedEndDate);

  return {
    plannedStartDate,
    plannedEndDate,
    remainingDays,
    plannedRuntime,
    actualStartDate,
    actualEndDate,
    currentRuntime,
    actualRuntime,
    progress,
    isRuntimeUnknown,
  };
}
